import { computed, ref, onMounted, onUnmounted } from 'vue'

export default function useBreakpoints() {
  const md = 768
  const lg = 1024
  const xl = 1280

  let windowWidth = ref(window.innerWidth)
  const onWidthChange = () => windowWidth.value = window.innerWidth
  onMounted(() => window.addEventListener('resize', onWidthChange))
  onUnmounted(() => window.removeEventListener('resize', onWidthChange))
  const screenWidth = computed(() => windowWidth.value)

  const screenType = computed(() => {
    if (windowWidth.value >= md && windowWidth.value < lg) return 'md'
    if (windowWidth.value >= lg && windowWidth.value < xl) return 'lg'
    if (windowWidth.value >= xl) return 'xl'
    return 'xs'
  })

  return { screenWidth, screenType }
}